import { validateValueLenthe } from "./validators";
import { sha256 } from 'js-sha256';

export const hashPassword = async (password) => {
  return sha256(password);
};

export const validatePasswordStrength = (password) => {
  if (!password) return { valid: false, msg: "Le mot de passe est requis." };
  if (!validateValueLenthe(password, 6)) return { valid: false, msg: "Le mot de passe doit contenir au moins 6 caractères." }; // Vérification longueur minimale \\
  if (!/[A-Z]/.test(password)) return { valid: false, msg: "Le mot de passe doit contenir au moins une lettre majuscule." }; // Vérification présence majuscule \\
  if (!/[a-z]/.test(password)) return { valid: false, msg: "Le mot de passe doit contenir au moins une lettre minuscule." }; // Vérification présence minuscule \\
  if (!/[0-9]/.test(password)) return { valid: false, msg: "Le mot de passe doit contenir au moins un chiffre." }; // Vérification présence chiffre \\
  if (!/[!?#%$£:*]/.test(password)) return { valid: false, msg: "Le mot de passe doit contenir au moins un caractère spécial (!?#%$£:*)." }; // Vérification présence caractère spécial \\
  return { valid: true, msg: "" };
};